import {
  parseTopicsArray,
  parseKeywordsArray,
  addSpeakersToSpeakerArray,
  parseWordsArray,
} from './utility';

const parse = (dataOriginal) => {
  // At the moment, we expect the schema of a call to match the returned schema of a /media/${id}
  // call which looks like {_links: {}, media: {}}. The following code is legacy expecting just
  // the media property so we break it out here.

  const data = dataOriginal.media;

  let topics = [];
  let groups = [];
  let speakers = [];
  let transcript = [];
  let transcriptSpeakers = [];

  if (data.keywords && data.keywords.latest && data.keywords.latest.words) {
    const { keywords, speakers: keywordSpeakers } = parseKeywordsArray(data.keywords.latest.words);
    topics.push({
      name: 'ALL TOPICS',
      type: 'category',
      keywords,
      speakers: keywordSpeakers,
    });
    speakers = addSpeakersToSpeakerArray(speakers, keywordSpeakers);
  }

  if (data.keywords && data.keywords.latest && data.keywords.latest.groups) {
    const { topics: groupsArrayTopics, speakers: groupsArraySpeakers } =
      parseTopicsArray(data.keywords.latest.groups);
    groups = groups.concat(groupsArrayTopics);
    speakers = addSpeakersToSpeakerArray(speakers, groupsArraySpeakers);
  }

  if (data.topics && data.topics.latest && data.topics.latest.topics) {
    const { topics: topicsArrayTopics, speakers: topicsArraySpeakers } =
      parseTopicsArray(data.topics.latest.topics);
    topics = topics.concat(topicsArrayTopics);
    speakers = addSpeakersToSpeakerArray(speakers, topicsArraySpeakers);
  }

  if (data.transcripts && data.transcripts.latest && data.transcripts.latest.words) {
    const {
      words: wordsArrayWords,
      speakers: wordsArraySpeakers,
      transcriptSpeakers: wordsArrayTranscriptSpeakers,
    } =
      parseWordsArray(data.transcripts.latest.words);
    transcript = transcript.concat(wordsArrayWords);
    speakers = addSpeakersToSpeakerArray(speakers, wordsArraySpeakers);
    transcriptSpeakers = wordsArrayTranscriptSpeakers;
  }

  return {
    activeTopic: 0,
    topics,
    activeGroup: 0,
    groups,
    activeSpeaker: 0,
    speakers,
    transcriptSpeakers,
    transcript,
    categories: {},
    // TODO: Implement classifiers in v2 if required later.
    // They are mixed in with other predictions though which makes it hard.
    classifiers: null,
  };
};

export default parse;
